import React, { useState } from "react";
import { Modal, Select } from "antd";
import Form, { InputField } from '../../../../components/form';
import styles from "../../../../../src/pages/admin/styles.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "@store/types";

const { Option } = Select;

interface Role {
    id: string;
    name: string;
  }
  
  interface CreateGroupProps {
    visible: boolean;
    onCancel: () => void;
    submitButtons?: React.ReactNode;
    onSubmit: (values: { name: string; roles: Role[] }) => void;
    roles: Role[];
  }

const CreateGroup: React.FC<CreateGroupProps> =({ visible, onCancel, roles, submitButtons, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const handleCreate = (values: any) => {
    try {
      setLoading(true);
      const payload = {
        name: values.name,
        roles: roles.filter((role) => selectedRoles.includes(role.id)),
      };
     onSubmit(payload);
    } catch (error) {
      setLoading(false);
      console.error("Error in handleCreate:", error);
    }
  };
  

  return (
    <Modal
      title="Create Group"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
    <Form
            initialValues={{name:'', roles:[]}}
            // validationSchema={userFormSchema}
            onSubmit={handleCreate}
            enableReinitialize
        >
            <div
                className={styles['userInfoForm']}
            >
                <InputField 
                    name="name"
                    label="Group Name"
                    required
                />
                 <Select mode="multiple" placeholder="Select roles" value={selectedRoles} onChange={(value) => setSelectedRoles(value)}>
            {roles.map((role:any) => (
              <Option key={role.id} value={role.id}>
                {role.name}
              </Option>
            ))}
          </Select>
                </div>
                {!!submitButtons && submitButtons}
        </Form>
    </Modal>
  );
};

export default CreateGroup;
